export default {
    root: {
        '& *': {
            textDecoration: 'none',
        },
    },
    textField: {
        margin: '10px 15px',
        fontSize: '14px',
        color: '#003764',
        '& label': {
            fontSize: '14px',
            color: '#003764',
            top: '5px',
        },
        '& input': {
            width: '266px',
            height: '25px',
            borderWidth: '0 0 1px',
            borderColor: '#003764',
        },
        '& p': {
            width: '267px',
            position: 'absolute',
            top: '50px',
        },
        '& input:focus': {
            outline: 'none',
        },
        '& input::placeholder': {
            color: '#003764;',
        },
    },
    optionalTextField: {
        margin: '10px 15px',
        fontSize: '14px',
        color: '#003764',
        '& label': {
            fontSize: '14px',
            color: '#003764',
            top: '5px',
        },
        '& input': {
            width: '198px',
            height: '25px',
            borderWidth: '0 0 1px',
            borderColor: '#003764',
        },
        '& p': {
            width: '267px',
            position: 'absolute',
            top: '50px',
        },
        '& input:focus': {
            outline: 'none',
        },
        '& input::placeholder': {
            color: '#003764',
        },
    },
    changeTextField: {
        margin: '10px 15px',
        fontSize: '14px',
        color: '#003764',
        '& label': {
            fontSize: '14px',
            color: '#003764',
            top: '5px',
        },
        '& input': {
            width: '212px',
            height: '25px',
            borderWidth: '0 0 1px',
            borderColor: '#003764',
        },
        '& p': {
            width: '267px',
            position: 'absolute',
            top: '50px',
        },
        '& input:focus': {
            outline: 'none',
        },
        '& input::placeholder': {
            color: '#003764',
        },
    },
    inputAdornment: {
        color: '#00A5B5',
        fontSize: '14px',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    passwordTextField: {
        margin: '10px 15px',
        fontSize: '14px',
        color: '#003764',
        '& label': {
            fontSize: '14px',
            color: '#003764',
            top: '5px',
        },
        '& input': {
            width: '211px',
            height: '25px',
            borderWidth: '0 0 1px',
            borderColor: '#003764',
        },
        '& p': {
            width: '267px',
            position: 'absolute',
            top: '50px',
        },
        '& input:focus': {
            outline: 'none',
        },
        '& input::placeholder': {
            color: '#003764',
        },
    },
    termsError: {
        marginLeft: '15px',
        color: '#F44335',
        display: 'flex',
        width: '100%',
        fontSize: '11px',
    },
    termsConditionLink: {
        color: '#153862',
        fontSize: '14px',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    enrollerName: {
        color: 'rgba(0, 0, 0, 0.38)',
        fontSize: '12px',
    },
    //new - design
    labelContent: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#153862',
        marginTop: '15px',
        marginBottom: '5px',
        '&': {
            display: 'inline-block',
        },
        '&::first-letter': {
            textTransform: 'uppercase',
        },
    },
    textFld: {
        // background: "#F7FAFC",
        // "& p": {
        //   position:"absolute",
        //   top:"50px",
        //   textAlign: "right",
        //   display: "block",
        //   width: "100%",
        // },
    },
    privacy_policy: {
        maxWidth: '370px',
        marginTop: '12px',
        '& a': {
            color: '#153862',
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/FormCountries/formElements.style.js